import MoodCategory from './elements/MoodCategory';
import OnDemandVod from './elements/OnDemandVod';
import { getTransformedCategories } from './helper';

// This component will use for Moods OnDemand Movies and TVShows
const OnDemand = ({ mood, onChangeMood }) => (
    <MoodCategory
        mood={mood}
        onChangeMood={onChangeMood}
        Component={OnDemandVod}
        titleKey={mood?.title_resource_key || 'mood_recommendation_categories_title'}
        getCategories={(mood) => getTransformedCategories(mood.data.content)}
        loading={!mood.data.content}
        isVod={true}
    />
);

export default OnDemand;
